// extracted by mini-css-extract-plugin
module.exports = {"image":"NecklaceOption_image__25raB","disabled":"NecklaceOption_disabled__q_zQE"};